__turbopack_context__.v({
  "awardsWrapper": "style-module-scss-module__TBZmpq__awardsWrapper",
  "bottomWrapper": "style-module-scss-module__TBZmpq__bottomWrapper",
  "circle": "style-module-scss-module__TBZmpq__circle",
  "circleMask": "style-module-scss-module__TBZmpq__circleMask",
  "clear": "style-module-scss-module__TBZmpq__clear",
  "curvedContainer": "style-module-scss-module__TBZmpq__curvedContainer",
  "curvedText": "style-module-scss-module__TBZmpq__curvedText",
  "curvedWrapper": "style-module-scss-module__TBZmpq__curvedWrapper",
  "curvedWrapperRelative": "style-module-scss-module__TBZmpq__curvedWrapperRelative",
  "titleWrapper": "style-module-scss-module__TBZmpq__titleWrapper",
  "wrapper": "style-module-scss-module__TBZmpq__wrapper",
});
